<template>
  <div
    class="item-container"
    :class="[isTimelineVisible ? 'is-orange' : 'is-grey']"
  >
    <div class="title-status" @click="isTimelineVisible = !isTimelineVisible">
      <div>
        <span class="title">{{ `ID: ${item.id}` }} -&nbsp;</span>
        <span
          class="title"
          :class="[isTimelineVisible ? 'is-orange' : 'is-grey']"
          >{{ getItemInformation() }}</span
        >
      </div>
      <div class="expand-timeline">
        <span class="status">{{ itemStatus }}</span>
        <button :class="[isTimelineVisible ? 'is-up' : 'is-down']">
          &#9002;
        </button>
      </div>
    </div>
    <div class="inverse-order">
      <p v-if="item.inverseOrder">
        Ordem Inversa: <span class="title">{{ item.inverseOrder }}</span>
      </p>
      <p v-if="item.serieNumber">
        Numero de Série: <span class="title">{{ item.serieNumber }}</span>
      </p>
    </div>
    <div class="timeline-content">
      <Timeline v-show="isTimelineVisible" :status="item.status" />
    </div>
    <a :download="buildReportFileName(item)" :href="`${item.reportFile}`" @click.prevent.stop="showAttachment('report')">
      <div class="button" v-if="item.reportFile">
        <span class="info">Laudo</span>
      </div>
    </a>
    <div class="disapproval-reason" v-if="item.disapprovalReason">
      <span>Motivo da recusa:&nbsp;</span>
      <span class="disapproval-info">{{ item.disapprovalReason }}</span>
    </div>
  </div>
</template>

<script>
import Timeline from "@/components/home/return-tracking/Timeline.vue";
import FilesService from "../../../services/return-tracking/file-service"
import { EventBus } from "@/eventHub";
export default {
  name: "ItemReturnTracking",
  components: {
    Timeline
  },
  props: ["item"],
  data() {
    return {
      isTimelineVisible: true,
      itemStatus: this.item.status
    };
  },
  methods: {
    buildReportFileName(item) {
      return `${item.reportFileName}.${item.reportFileType}`;
    },
    getItemInformation() {
      return `${this.item.material} - PN: ${this.item.partNumber}`;
    },
    showAttachment(attachment) {
      EventBus.$emit("showPreLoader");
      FilesService.getAttachment(attachment, this.item.id)
              .then(({ data }) => {
                const base64 = data.split(";");
                const format = base64[0].split("/");
                EventBus.$emit("hidePreLoader");
                if (format[1] === "pdf") {
                  const iframe = `
        <iframe src=${data} height='100%' width='100%'></iframe>
        `;
                  const w = window.open("", "", "width=auto,height=auto");
                  w.document.write(iframe);
                } else {
                  const iframe = `
          <div style="heigth=100%; width=100%;">
            <img src=${data} alt="No image">
          </div>
        `;
                  const w = window.open("", "", "width=auto,height=auto");
                  w.document.write(iframe);
                }
              });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_colors.scss";
.item-container {
  border-left: 2px solid $grey1;
  background-color: $white;
  margin: 30px 2% 0 2%;
  width: 95%;
  max-height: 280px;
  min-width: 580px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  .title-status {
    display: flex;
    justify-content: space-between;
    margin: 15px 20px;
    span {
      align-items: center;
      font-weight: bold;
    }
    div {
      display: flex;
      align-items: center;
    }
    .title {
      color: $grey2;
    }
    .status {
      color: $orange1;
    }
    &:hover,
    &:hover span {
      cursor: pointer;
      border-color: $orange1;
    }
  }
  .inverse-order {
    margin: 0;
    font-weight: bold;
    color: $grey2;
    padding-left: 20px;
    .title {
      color: $grey2;
    }

    & p:last-child {
      margin-bottom: 10px;
    }
  }
  .disapproval-reason {
    display: flex;
    justify-content: flex-start;
    margin: 15px 20px;
    color: $grey1;
    font-weight: bold;
    .disapproval-info {
      color: $orange1;
    }
  }
  a {
    text-decoration: none;
  }
  .button {
    margin: 0 20px 15px 20px;
    background-color: $orange1;
    border: none;
    padding: 0;
    height: 36px;
    width: 170px;
    font-size: 14px;
    text-transform: uppercase;
    outline: none;
    cursor: pointer;
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      color: white;
    }
    &:hover {
      background-color: $orange1;
    }
  }
  .timeline-content {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .expand-timeline {
    display: flex;
    justify-content: flex-end;
    margin-top: -5px;
    button {
      color: $grey1;
      width: 25px;
      height: 25px;
      outline: none;
      text-align: center;
      background: none;
      border: none;
      font-size: 17px;
      line-height: 25px;
      margin-left: 15px;
      cursor: pointer;
    }
  }
  &:hover {
    border-color: $orange1;
  }
}
.item-container:last-child {
  margin-bottom: 20px;
}
.is-orange {
  border-color: $orange1;
}
.is-grey {
  // border-color: $grey2;
  background-color: #9e9e9e;
}
.is-up {
  transform: rotate(270deg);
}
.is-down {
  transform: rotate(90deg);
}
@media only screen and (max-width: 1480px) {
  .item-container {
    font-size: 14px;
  }
}
</style>
